import { HIDE_POPUP } from "core-web/state/models/Popups/constants";
import store from "core-web/state/store";

export const hidePopup =
    (popup = null, uniqueIdentifier = null) =>
    (dispatch) => {
        dispatch({
            type: HIDE_POPUP,
            popup,
            uniqueIdentifier,
        });
    };

export default (popup, uniqueIdentifier) => store.dispatch(hidePopup(popup, uniqueIdentifier));
